import * as Effects from 'redux-saga/effects'
import { flushState } from '../../../actions/userAccount/authorize/unauthorize'
import { driver, names } from '../../../database/localStorage'
import { SynchronizeActions } from '../../../reducers/synchronize/actionNames'
import getVersion from '../../../reducers/synchronize/selectors/getVersion'
import flushEvents from '../removers/flushEvents'
import flushRooms from '../removers/flushRooms'

function* reload() {
  const verison = yield Effects.select(getVersion)

  driver.setItem(names.UserAccountStorage.Version, verison)

  yield* flushEvents()
  yield* flushRooms()
  yield Effects.put(flushState())

  window.location.reload()
}

export default function*() {
  yield Effects.takeEvery(SynchronizeActions.ReloadApp, reload)
}
